import { onMounted } from 'vue'
import { useRouter, useRoute } from 'vue-router'

/**
 * Syncs a reactive filter `data` object to/from URL query params.
 *
 * Usage in any Filter.vue:
 *   const { pushToUrl, clearUrl } = useUrlQuery(data)
 *   // in filter(): pushToUrl()
 *   // in reset():  clearUrl()
 *
 * On mount, the data object is restored from the current URL query.
 */
export function useUrlQuery(data, onRestore) {
  const router = useRouter()
  const route = useRoute()

  onMounted(() => {
    const q = route.query
    let restored = false
    for (const key of Object.keys(data)) {
      if (q[key] !== undefined && q[key] !== '') {
        data[key] = q[key]
        restored = true
      }
    }
    if (restored && onRestore) onRestore()
  })

  function pushToUrl() {
    const query = {}
    for (const [k, v] of Object.entries(data)) {
      if (v !== null && v !== undefined && v !== '') {
        query[k] = String(v)
      }
    }
    router.replace({ query })
  }

  function clearUrl() {
    router.replace({ query: {} })
  }

  return { pushToUrl, clearUrl }
}
